module.exports = __webpack_public_path__ + "static/media/BUSD-USDC.347964b5.svg";